/*
 * @Description: myredhat-web
 * @Version: 1.0
 * @Autor: 李航
 * @Date: 2021-11-12 14:59:40
 * @LastEditors: 李航
 * @LastEditTime: 2021-11-12 15:12:55
 */

import Vue from 'vue'
import Router from 'vue-router'
// element组件
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

// 视频播放组件
import VideoPlayer from 'vue-video-player'
import 'video.js/dist/video-js.css'
// import 'vue-video-player/src/custom-theme.css'

Vue.use(Router)
Vue.use(ElementUI)
Vue.use(VideoPlayer)

export default new Router({
  mode: 'history',
  routes: [
    { path: "/", redirect: "Home" },
    { path: "/Home", component: () => import('../views/Home.vue') },/* 首页 */
    { path: "/Product", component: () => import('../views/Product.vue') },/* 产品中心 */
    { path: '/Solve', component: () => import('../views/Solve.vue') },/* 解决方案 */
    { path: '/Cooperation', component: () => import('../views/Cooperation.vue') },/* 合作客户 */
    { path: '/Consult', component: () => import('../views/Consult.vue') },/* 行业咨询 */
    { path: '/Relation', component: () => import('../views/Relation.vue') },/* 联系我们 */
    { path: '/ConsultDetails/:id', component: () => import('../views/ConsultDetails.vue') },
    { path: '/ProductDetails/:id', component: () => import('../views/ProductDetails.vue') },
    { path: '/About', component: () => import('../views/About.vue') },/* 关于我们 */
    { path: '/Video', component: () => import('../views/Video.vue') },/* 视频 */
  ]
})
